// extracted by mini-css-extract-plugin
export default {"link":"MatchToolsLinks_link__e1-R2"};